/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import * as React from 'react';
import getComponentName from 'react-utils/getComponentName';
import { attachWrappedComponent } from './utils';
import { fontsLoaded, fontsLoadedPromise } from '../utils/Fonts';
import { requestIdleCallback, cancelIdleCallback } from '../utils/Timers';
import { jsx as _jsx } from "react/jsx-runtime";
export default function (Component) {
  class MeasureInputDecorator extends React.Component {
    constructor(props) {
      super(props);
      this.measureInput = () => {
        if (!this._isMounted) return; // Handle edge case where fontsLoadedPromise fires after unmount
        const inputNode = this.props.inputRef.current;
        const inputWidth = inputNode.offsetWidth;
        if (inputWidth !== this.state.inputWidth) {
          this.setState({
            inputWidth
          });
        }
      };
      this.handleWindowResize = () => {
        cancelIdleCallback(this._resizeTimer);
        this._resizeTimer = requestIdleCallback(this.measureInput);
      };
      this.state = {
        inputWidth: null
      };
    }
    componentDidMount() {
      this._isMounted = true;
      addEventListener('resize', this.handleWindowResize);
      this.measureInput();
      if (!fontsLoaded()) fontsLoadedPromise.then(this.measureInput);
    }
    componentDidUpdate(prevProps, prevState) {
      // ⚠️ This condition prevents infinite loops! ⚠️
      if (prevState.inputWidth === this.state.inputWidth) {
        this.measureInput(this);
      }
    }
    componentWillUnmount() {
      removeEventListener('resize', this.handleWindowResize);
      cancelIdleCallback(this._resizeTimer);
      this._isMounted = false;
    }
    render() {
      return /*#__PURE__*/_jsx(Component, Object.assign({}, this.props, {
        inputWidth: this.state.inputWidth
      }));
    }
  }
  const componentName = getComponentName(Component);
  MeasureInputDecorator.displayName = `MeasureInput(${componentName})`;
  MeasureInputDecorator.propTypes = Component.propTypes;
  MeasureInputDecorator.defaultProps = Component.defaultProps;
  attachWrappedComponent(MeasureInputDecorator, Component);
  return MeasureInputDecorator;
}